/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import styles from './WarningModal.module.css';
import clsx from 'clsx';

const BrowserBackModal = ({ handleClose, open, confirm }) => (
    <Modal open={open} >
        <div className={styles.container}>
            <div className={clsx(styles.titleSearch, "largeFont")}>
                <span>
                    {' '}
                    <SearchIcon className={styles.block} fontSize="1rem" />
                </span>
                <span className={styles.txt}>Warning</span>
            </div>
            <Box bgcolor="#dadada3d" marginTop="13px" height="75px" marginLeft="9px">
                <p className={clsx(styles.warningText, "largeFont")}>
                    The searched data will be lost, please download csv.
                </p>
            </Box>
            <div className={styles.bottomRow}>
                <button className={clsx(styles.cancelBt, "regularFont")} onClick={handleClose}>
                    OK
                </button>
                <span>
                    <button
                        onClick={(data) => {
                            handleClose();
                            confirm(data);
                        }}
                        className={clsx(styles.submitBt, "regularFont")}
                    >
                        Go Back
                    </button>
                </span>
            </div>
        </div>
    </Modal>
);

BrowserBackModal.propTypes = {
    confirm: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
};

export default BrowserBackModal;
